import { JSPost } from './Common.js';
import Cookies from 'js-cookie';
import { Common } from './Common.js';
import DialogMgr from './DialogMgr.js';

var StaticFrequencySetMgmtVM = function (jsonData) {
  var self = this;

  self.defaultListCount = 50;
  self.loadedCount = 0;
  self.cookieName = 'efcStaticFrequencySetSearch';
  var searchCookie = Cookies.getJSON(self.cookieName);

  var filterOn = jsonData.FilterOnCustom == true ? jsonData.StaticFrequencySetSearch : searchCookie || jsonData.StaticFrequencySetSearch;
  self.StaticFrequencySetSearch = new StaticFrequencySetSearch(filterOn, self.defaultListCount);
  self.StaticFrequencySetSearchHold = new StaticFrequencySetSearch(filterOn, self.defaultListCount);

  self.Areas = ko.observableArray((jsonData.Areas || []).sort(Common.StringSortFunc('Name')));
  self.Locations = ko.observableArray((jsonData.Locations || []).sort(Common.StringSortFunc('Name')));
  self.Statuses = ko.observableArray(jsonData.Statuses || []);
  self.EnableAreas = ko.observable(jsonData.Areas && jsonData.Areas.length > 1);
  if (!self.EnableAreas()) {
    //User only has access to 1 area and should always stay selected
    self.StaticFrequencySetSearch.AreaIDs(jsonData.StaticFrequencySetSearch.AreaIDs);
    self.StaticFrequencySetSearchHold.AreaIDs(jsonData.StaticFrequencySetSearch.AreaIDs);
  }

  self.load = function () {
    if (self.StaticFrequencySetSearchHold.AreaIDs().length > 0) self.ReloadSearchLocations(self.StaticFrequencySetSearchHold.AreaIDs());

    self.setupSearchToggle($('#menu-toggle'));
    self.setAreaChangeTrigger($('#searchAreaID'));

    ko.applyBindings(self, document.getElementById('wrapper'));

    Common.ShowSelectedItemsOnTop('#searchAreaID');
    Common.ShowSelectedItemsOnTop('#searchLocationID');

    self.LoadList();
  };

  self.LoadList = function (callback) {
    $('#loadMessage').show();
    $('#sectStaticFrequencySetList').load(
      RazorShared.baseUrl + 'StaticFrequency/GetStaticFrequencySetList',
      ko.toJS(self.StaticFrequencySetSearch),
      function (response, status, xhr) {
        if (status == 'error') Common.Dialog('Search', 'An error has occurred: ' + xhr.status + ' ' + xhr.statusText, null, xhr.status);
        else self.loadedCount = $('#numLoaded').val();
        $('#loadMessage').hide();
      }
    );
    Cookies.set(self.cookieName, ko.toJS(self.StaticFrequencySetSearch), {
      expires: 30
    });
  };

  self.ApplyFilters = function () {
    var temp = self.StaticFrequencySetSearch;
    self.StaticFrequencySetSearch = new StaticFrequencySetSearch(ko.toJS(self.StaticFrequencySetSearchHold), self.defaultListCount);
    self.StaticFrequencySetSearch.SortBy = temp.SortBy;
    self.StaticFrequencySetSearch.SortDesc = temp.SortDesc;
    self.LoadList();
  };

  self.ListMore = function () {
    if (self.StaticFrequencySetSearch.RetrieveCount > self.loadedCount)
      // already loaded everything
      return;
    self.StaticFrequencySetSearch.RetrieveCount += self.defaultListCount;
    self.LoadList();
  };

  self.SetSort = function (sort) {
    if (self.StaticFrequencySetSearch.SortBy == sort) {
      self.StaticFrequencySetSearch.SortDesc = !self.StaticFrequencySetSearch.SortDesc;
    } else {
      self.StaticFrequencySetSearch.SortBy = sort;
      self.StaticFrequencySetSearch.SortDesc = false;
    }
    self.LoadList();
  };

  self.ClearSearch = function () {
    self.StaticFrequencySetSearch.ClearSearch(self.defaultListCount);
    self.StaticFrequencySetSearchHold.ClearSearch(self.defaultListCount);
    if (!self.EnableAreas()) {
      //User only has access to 1 area and should always stay selected
      self.StaticFrequencySetSearch.AreaIDs(jsonData.StaticFrequencySetSearch.AreaIDs);
      self.StaticFrequencySetSearchHold.AreaIDs(jsonData.StaticFrequencySetSearch.AreaIDs);
    }
    self.LoadList();
  };

  self.ActivateFrequencySet = function (id) {
    $.post(RazorShared.baseUrl + 'StaticFrequency/ActivateStaticFrequencySet/' + id, function (data) {
      if (data.success) self.LoadList();
      else Common.Dialog('Error activating frequency set', null, data.error);
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      Common.Dialog('Activate Frequency Set', textStatus + '/' + errorThrown, null, XMLHttpRequest.status);
    });
  };

  self.ShowDeactivateConfirmation = function (id, name) {
    Common.DialogConfirmation(
      'Deactivate Static Frequency Set',
      null,
      '<span>Do you want to remove ' +
        name +
        ' from all future Activities to which it had been assigned?</span>' +
        "<select id='removeFromFutureActivity' style='margin-left:10px'><option value='1'>Yes</option><option value='0'>No</option></select>",
      function () {
        self.DeactivateFrequencySet(id, $('#removeFromFutureActivity').val());
      },
      null
    );
  };

  self.DeactivateFrequencySet = function (id, doRemove) {
    var removeFromFutureActivities = doRemove == '1' ? true : false;
    $.post(
      RazorShared.baseUrl + 'StaticFrequency/DeactivateStaticFrequencySet/',
      { id: id, removeFromFutureActivities: removeFromFutureActivities },
      function (data) {
        if (data.success) self.LoadList();
        else Common.Dialog('Error deactivating frequency set', null, data.error);
      }
    ).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      Common.Dialog('Deactivate Frequency Set', textStatus + '/' + errorThrown, null, XMLHttpRequest.status);
    });
  };

  self.ViewFilteredStaticFrequencies = function (id) {
    var params = { staticFrequencySetID: id || 0, filterOnSetOnly: true };
    JSPost(RazorShared.baseUrl + 'StaticFrequency/StaticFrequencies/', params);
  };

  self.AssignFrequencies = function (areaID, setID) {
    sessionStorage.removeItem('currentIdx');
    var params = {
      areaID: areaID,
      search: ko.toJS(self.StaticFrequencySetSearch),
      selSetID: setID
    };
    JSPost(RazorShared.baseUrl + 'AssignStaticFrequencies/', params);
  };

  self.AddStaticFrequencySet = function () {
    DialogMgr.AddEditStaticFrequencySet(0, self.LoadList);
  };

  self.EditStaticFrequencySet = function (staticFrequencySetID) {
    DialogMgr.AddEditStaticFrequencySet(staticFrequencySetID, self.LoadList);
  };

  self.AddStaticFrequency = function (staticFrequencySetID) {
    DialogMgr.StaticFrequencyAdd(staticFrequencySetID, self.LoadList);
  };

  self.DuplicateSet = function (id) {
    DialogMgr.DuplicateStaticFrequencySet(id, self.LoadList);
  };

  self.ReloadSearchLocations = function (areaIDs) {
    $.post(RazorShared.baseUrl + 'StaticFrequency/GetLocationsForAreas', { areaIDs: areaIDs }, function (data) {
      if (data.success) {
        self.StaticFrequencySetSearch.LocationIDs.removeAll();
        self.Locations(data.AvailLocations.sort(Common.StringSortFunc('Name')));
      } else {
        Common.Dialog('Error finding locations', null, data.error);
      }
    }).fail(function (XMLHttpRequest, textStatus, errorThrown) {
      Common.Dialog('Find Locations', textStatus + '/' + errorThrown, null, XMLHttpRequest.status);
    });
  };

  self.setupSearchToggle = function ($fld) {
    var toggleCookieName = self.cookieName + '_displayToggled';
    var cookie = Cookies.get(toggleCookieName);
    if (cookie) $fld.click();

    $fld.on('displayToggled', function () {
      if ($(this).hasClass('toggled')) Cookies.set(toggleCookieName, 'toggled');
      else Cookies.remove(toggleCookieName);
    });
  };

  self.setAreaChangeTrigger = function ($fld) {
    self.StaticFrequencySetSearchHold.AreaIDs.subscribe(function (newVaules) {
      self.ReloadSearchLocations(newVaules);
    });
  };

  self.AssignToActivities = function (staticFrequencySetID) {
    DialogMgr.AssignToActivities(staticFrequencySetID, self.LoadList);
  };
};

var StaticFrequencySetSearch = function (jsonData, defaultCount) {
  var self = this;

  self.SortBy = jsonData.SortBy || 0;
  self.SortDesc = jsonData.SortDesc || false;
  self.RetrieveCount = defaultCount;
  self.RetrieveStartAt = jsonData.RetrieveStartAt || null;

  self.AreaIDs = ko.observableArray(jsonData.AreaIDs || []);
  self.LocationIDs = ko.observableArray(jsonData.LocationIDs || []);
  self.NameLike = ko.observable(jsonData.NameLike || null);
  self.Statuses = ko.observableArray(jsonData.Statuses || [1, 3]);

  self.ClearSearch = function (defaultCount) {
    if (defaultCount == undefined) return;

    self.AreaIDs([]);
    self.LocationIDs([]);
    self.NameLike(null);
    self.Statuses([1, 3]);

    self.RetrieveCount = defaultCount;
    self.RetrieveStartAt = null;
  };
};

export default StaticFrequencySetMgmtVM;
